<template>
    <div class="container bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-3"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100" style="max-height:80vh">
            <div class="container table-responsive">
                <button class="btn-close float-end mt-3" @click.prevent="close"></button>
                <h3 class="mt-3"><strong> Información previa de la forma </strong></h3>
                <table class="table table-bordered my-auto mx-auto">
                    <thead>
                        <tr>
                            <th scope="col">Grupo de formas asociado:</th>
                            <td scope="col"> <strong><i>{{ imgTubeFormFamilyName }}</i></strong></td>
                        </tr>
                        <tr>
                            <th scope="col">Nombre de la forma: </th>
                            <td scope="col">{{ imgTubeForm.imgFormName }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Forma</th>
                            <th colspan="4"><i> Servicios </i></th>
                        </tr>
                        <tr>
                            <th rowspan="9" class="p-2"> <img v-if="imgTubeForm && imgTubeForm.imgFile"
                                    :src="serverUrl + 'images/forms/' + imgTubeForm.imgFile" class="my-3 mx-2"
                                    style="max-width: 300px; max-height: 300px;" />
                            </th>
                        </tr>
                        <tr>
                            <td><strong>Oxicorte: </strong> {{ imgTubeForm.imgServiceFlameCutting }}</td>
                        </tr>
                        <tr>
                            <td><strong>Corte con plasma: </strong> {{ imgTubeForm.imgServicePlasmaCutting }}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Corte con láser: </strong> {{ imgTubeForm.imgServiceLaserCutting }}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Rolado: </strong> {{ imgTubeForm.imgServiceRolled }}</td>
                        </tr>
                        <tr>
                            <td><strong>Soldadura electrodo: </strong> {{
                                imgTubeForm.imgServiceWeldingElectrode }}</td>
                        </tr>
                        <tr class="mt-2">
                            <td><strong>Soldadura MIG: </strong> {{
                                imgTubeForm.imgServiceWeldingMig }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="container table-responsive">
                <h3 class="mt-3"> <strong> Editar forma </strong></h3>
                <p> <strong>Nota: </strong><mark><i>No podrá editar el grupo de formas asociado para esta
                            forma.</i>
                    </mark></p>
                <p><mark>Además, tenga presente que luego de hacer clic en el botón "Actualizar forma", la información que
                        sumistre en el siguiente espacio sutituirá por completo la información previa de la forma.</mark>
                </p>
                <p>
                    <strong>Atención: </strong><mark> <i>Los campos que se encuentren vacios al momento de hacer clic en el
                            botón "Actualizar forma", contarán como
                            modifaciones.</i></mark>
                </p>
                <table class="table table-responsive">
                    <tbody>
                        <tr>
                            <th colspan="2">
                                <p><i class="requiredFields">* </i>Nuevo nombre para la forma:</p>
                            </th>
                            <td colspan="3"><input type="text" v-model="editImageForm" class="form-control"
                                    id="editImageForm" />
                            </td>
                        </tr>
                        <tr>
                            <th colspan="2">
                                <p><i class="requiredFields">*</i> Nueva imagen para la forma:</p>
                            </th>
                            <td colspan="2"> <input type="file" class="form-control" id="editImageFile" ref="file"
                                    @change="previewFile" />
                            </td>
                            <td colspan="">
                                <mark>
                                    <input class="form-check-input" type="checkbox" role="switch" id="imageFile"
                                        v-model="newImageFileAvailable" />
                                    <i> Mantener imágen previa de la forma.</i>
                                </mark>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">
                                <h5 class="mt-3"><i> Actualizar servicios requeridos por la forma</i></h5>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Oxicorte: </td>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceFlameCutting" v-model="editImgServiceFlameCutting" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceFlameCutting">Aplica</label>
                            </td>
                            <td>Corte con plasma: </td>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSevicePlasmaCutting" v-model="editImgServicePlasmaCutting" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServicePlasmaCutting">Aplica</label>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Corte con láser: </td>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceLaserCutting" v-model="editImgServiceLaserCutting" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceLaserCutting">Aplica</label>
                            </td>
                            <td>Rolado: </td>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch" id="imgSeviceRolled"
                                    v-model="editImgServiceRolled" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceRolled">Aplica</label>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Soldadura electrodo: </td>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceWeldingElectrode" v-model="editImgServiceWeldingElectrode" />
                                <label class="form-check-label ms-4 mt-1"
                                    for="editImgServiceWeldingElectrode">Aplica</label>
                            </td>
                            <td>Soldadura MIG:</td>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceWeldingMig" v-model="editImgServiceWeldingMig" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceWeldingMig">Aplica</label>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">
                                <mark>
                                    <input class="form-check-input" type="checkbox" role="switch" id="imageFile"
                                        v-model="newServicesAvailable" />
                                    <i> Mantener <strong>todos</strong> los servicios previos.</i>
                                </mark>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-danger mt-2 mb-3 mx-auto" @click.prevent="saveChanges()">
                    Actualizar forma
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendImageId: Number,
    },
    data() {
        return {
            serverUrl: RUTA_SERVIDOR,
            //LastInfo
            imgTubeForm: [],
            imgTubeFormFamilyName: "",
            //Edit Fields
            editImageForm: "",
            editImageOrder: 0,
            editImgServiceFlameCutting: false,
            editImgServicePlasmaCutting: false,
            editImgServiceLaserCutting: false,
            editImgServiceRolled: false,
            editImgServiceWeldingElectrode: false,
            editImgServiceWeldingMig: false,
            editImgServicePunching1: false,
            editImgServicePunching2: false,
            //Optimización para en caso de no actualizar la imágen 
            newImageFileAvailable: false,
            newServicesAvailable: false,

        };
    },
    watch: {
        sendImageId(newVal) {
            if (newVal !== null) {
                this.getTubeInfo();
            }
        },
    },
    methods: {
        previewFile(event) {
            // this.editImageFile = event.target.files;
            // this.editImageFile2 = event.target.files[0];
            // console.log(this.editImageFile);
            // console.log(this.editImageFile2);
            this.editImageFile = this.$refs.file.files;
            // console.log(this.editImageFile);
            this.editCurrentFile = this.editImageFile.item(0);
            // console.log(this.editCurrentFile);
        },
        async saveChanges() {
            if ((this.editImageDistances === 0 && !this.newImageDimensionsAvailable) || this.editImageForm === "") {
                alert("Campos vacios, por favor complete aquellos que son obligatorios pimero.")
            } else {
                let formData = new FormData();
                formData.append("tube_image_id", this.sendImageId);
                formData.append("editImageForm", this.editImageForm);
                if (this.newImageFileAvailable) {
                    console.log(this.newImageFileAvailable);
                    formData.delete("editImageFile");
                    formData.delete("editImageName");
                } else {
                    formData.append("editImageFile", this.editCurrentFile);
                    formData.append("editImageName", this.editCurrentFile.name);
                }
                if (this.newServicesAvailable) {
                    formData.delete("editImgServiceFlameCutting");
                    formData.delete("editImgServicePlasmaCutting");
                    formData.delete("editImgServiceLaserCutting");
                    formData.delete("editImgServiceWeldingElectrode");
                    formData.delete("editImgServiceWeldingMig");
                    formData.delete("editImgServiceRolled");
                } else {
                    formData.append(
                        "editImgServiceFlameCutting",
                        this.editImgServiceFlameCutting ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServicePlasmaCutting",
                        this.editImgServicePlasmaCutting ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceLaserCutting",
                        this.editImgServiceLaserCutting ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceWeldingElectrode",
                        this.editImgServiceWeldingElect ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceWeldingMig",
                        this.editImgServiceWeldingMig ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceRolled",
                        this.editImgServiceRolled ? "aplica" : "no_aplica"
                    );
                }
                // formData.append("editImageOrder", this.editImageOrder);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/tube/image/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Forma: " + this.editImageForm + ", actualizada con exito!");
                        this.cleanFields();
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                    alert("Ups, algo salio mal!");
                }
                this.$emit("hideEditForm", false);
                location.reload();
            }
        },
        async getTubeInfo() {
            try {
                if (!this.sendImageId) {
                    console.log("Profile form id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/tube/image/get", {
                    params: {
                        tubeImg_id: this.sendImageId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.imgTubeForm = res.data[0];
                //console.log(this.imgTubeForm);
                this.imgTubeFormFamilyName = res.data[0]["imageFormFamily"]["name"];
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        close() {
            this.imgTubeForm = [];
            this.$emit("hideEditForm", false);
        },
        cleanFields() {
            this.editImageForm = "";
            this.editImageFile = null; // o this.imageFile = undefined;
            this.currentFile = null; // Restablece también la variable si es necesario
            this.editImgServiceFlameCutting = false;
            this.editImgServicePlasmaCutting = false;
            this.editImgServiceLaserCutting = false;
            this.editImgServiceRolled = false;
            this.editImgServiceWeldingElectrode = false;
            this.editImgServiceWeldingMig = false;
        }
    },
    mounted() {
        this.getTubeInfo();
    }
}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>